import {TabsService} from './../../pages/tabs/tabs.service';
import {NavController} from 'ionic-angular';
import {Component} from '@angular/core';
import {SessionService} from './../../services/session';
import {FiltersService} from '../../services/filters';
import {LocationsService} from '../../services/locations';

@Component({
  selector: 'app-summary-header',
  templateUrl: 'summary-header.html'
})
export class SummaryHeaderComponent {

  constructor(public sessionService: SessionService,
              public filtersService: FiltersService,
              public navCtrl: NavController,
              public tabsService: TabsService,
              public locationsService: LocationsService) {
  }

  goToMyClasses(classType) {
    this.filtersService.myClassesType = classType;
    this.navCtrl.parent.select(this.tabsService.MY_CLASSES)
  }
}



// WEBPACK FOOTER //
// ./src/components/summary-header/summary-header.ts